// extracted by mini-css-extract-plugin
export default {"ldsRipple":"Loader_ldsRipple__gLS85"};